import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-chase-response-success',
    templateUrl: './chase-response-success.component.html',
    styleUrls: ['./chase-response-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChaseResponseSuccessComponent implements OnInit {

  @Input() transactionID = null;
  @Input() transactionDate = null;
  @Input() transactionAmount = null;

  @Output() close = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  printInvoice(){
    this.close.emit();
  }

}
